<template>
  <div class="chameleon">
    <div class="corporate-name"><img :src="logo"></div>
    <div class="product-name">堤口果品市场智慧停车场</div>
    <div class="export">{{ formData.deveiceName ? formData.deveiceName : '' }}</div>
    <div class="export-info">
      <div class="plate">
        <div class="plate-left">车牌号码:<span @click="getData">(刷新)</span></div>
        <div class="righ-class">{{ formData.licensePlate ? formData.licensePlate : '0' }}</div>
      </div>
      <div class="plate2">
        <div class="plate-left">进场时间:</div>
        <div class="righ-class" style="margin-left:10px">{{ formData.timeIn ? formData.timeIn : '0' }}</div>
      </div>
      <div class="plate2">
        <div class="plate-left">出场时间:</div>
        <div class="righ-class" style="margin-left:10px">{{ formData.timeOut ? formData.timeOut : '0' }}</div>
      </div>
      <div class="plate">
        <div class="plate-left">停车时间:</div>
        <div class="righ-class">{{ formData.stayMins ? formData.stayMins : '0' }}分钟</div>
      </div>
      <div class="plate">
        <div class="plate-left">支付金额:</div>
        <div class="righ-class" style="display: flex;flex-direction: row;align-items: center;"><span
            style="color:red">{{ formData.parkMoney ? formData.parkMoney : '0' }}</span>元</div>
      </div>
    </div>
    <div class="btn">
      <el-button type="primary" v-if="retCode == '0' && radio == '1'"
        style="width:90%;height:50px;background:#04BE02;color:#fff;border:0" @click="goOrder">确认支付</el-button>
      <el-button type="primary" v-if="retCode == '0' && radio == '2'"
        style="width:90%;height:50px;background:#1678FF;color:#fff;border:0" @click="goOrder">确认支付</el-button>
      <el-button type="primary" v-if="retCode != '0'"
        style="width:90%;height:50px;background:#ddd;color:#fff;border:0">已支付</el-button>
    </div>
    <div style="margin-top:30px;font-size:20px;color:#969594;text-align: center;">若不抬杆请与市场管理员联系</div>
  </div>
</template>

<script>
import axios from 'axios'
import { get } from '../utils/request'

export default {
  name: 'HelloWorld',
  data() {
    return {
      formDatas: {
        deveiceNo: '',
        businessNo: '',
        payMoney: ''
      },
      logo: require('../assets/logo2.png'),
      radio: '1', // 支付方式  1是微信 2是支付宝
      formData: {}, //  页面展示需要的信息
      retCode: '1', //  支付状态 默认是不支付
      parkInfo: {
        deveiceNo: ' '// 设备编号
      },
      payInfo: {
        deveiceNo: ' ', // 设备编号
        businessNo: ' ', // 业务订单编号
        payType: ' ', // 支付方式(1-微信；2-支付宝)
        paySn: ' ', // 支付流水号(微信支付宝返回的流水号)
        payMoney: '' // 支付金额
      }
    }
  },
  mounted() {
    document.title = "停车缴费"
    // localStorage.removeItem("deveiceNo");
    // localStorage.removeItem("businessNo");
    // localStorage.removeItem("payType");
    // localStorage.removeItem("payMoney");
    // alert(localStorage.getItem("deveiceNo"))
    //是否是微信环境
    var ua = window.navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      //在微信里
      this.radio = '1'

    } else if (ua.match(/AlipayClient/i) == "alipayclient") {
      //在支付宝里
      this.radio = '2'
    }
    this.getData()
  },
  methods: {
    // 获取地址栏参数
    getQueryVariable(variable) {
      var query = window.location.href;
      //  var query = 'http://www.dkjtapp.com/?deveiceNo=0001#/'  //生成二维码的链接
      var querys = query.split('?')
      var pair = querys[1].split('=')
      var pairs = pair[1].split('#')

      if (pair[0] === variable) { return pairs[0] };
      return (false)
    },
    // 显示页面信息
    getData() {
      this.parkInfo.deveiceNo = this.getQueryVariable('deveiceNo')
      // console.log("parkInfo",this.parkInfo);
      get('/queryParkFee.do', this.parkInfo).then(data => {
        var res = data.data
        // console.log("获取车辆信息",res);
        this.retCode = res.retCode
        if (res.retCode == '0') {
          //页面信息展示
          this.formData = res
          //支付信息
          this.formDatas.deveiceNo = res.deveiceNo  //设备编号
          this.formDatas.businessNo = res.businessNo  //设备编号
          this.formDatas.payMoney = res.parkMoney  //设备编号
          //接口提交需要信息
          this.payInfo.deveiceNo = res.deveiceNo  //设备编号
          this.payInfo.businessNo = res.businessNo  //业务订单编号
          this.payInfo.payType = this.radio //支付方式
          // this.payInfo.paySn = res.paySn  //支付流水号 支付时产生的流水号
          this.payInfo.payMoney = res.parkMoney  //支付金额

        } else {
          //获取当前车辆信息失败或者没有信息
          alert(res.retMsg)

        }
      }).catch(err => { })

    },
    // 提交订单
    goOrder() {
      if (this.payInfo.payMoney > 50) {
        this.$confirm(
          '当前金额大于50元，是否继续支付？',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true,
            customClass: 'msgbox'
          }
        )
          .then(_ => {
            //是否是微信环境
            if (this.radio === '1') {
              //微信支付
              this.wxPayment()

            } else if (this.radio === '2') {
              // 支付宝支付
              this.alipay()
            }
          })
          .catch(_ => {
            console.log('取消支付');
          });
      } else {
        //是否是微信环境
        if (this.radio === '1') {
          //微信支付
          this.wxPayment()

        } else if (this.radio === '2') {
          // 支付宝支付
          this.alipay()
        }
      }


    },
    // 微信内支付
    wxPayment() {

      window.location.href = 'http://www.dkjtapp.com/wxpay.php?deveiceNo=' + this.formDatas.deveiceNo +
        '&businessNo=' + this.formDatas.businessNo + '&payMoney=' + this.formDatas.payMoney

      //信息存入缓存  
      localStorage.setItem("deveiceNo", this.payInfo.deveiceNo)
      localStorage.setItem("businessNo", this.payInfo.businessNo)
      localStorage.setItem("payType", this.payInfo.payType)
      localStorage.setItem("payMoney", this.payInfo.payMoney)

    },
    // 支付宝支付
    alipay() {
      window.location.href = 'http://www.dkjtapp.com/zfbpay.php?deveiceNo=' + this.formDatas.deveiceNo +
        '&businessNo=' + this.formDatas.businessNo + '&payMoney=' + this.formDatas.payMoney

      localStorage.setItem("deveiceNo", this.payInfo.deveiceNo)
      localStorage.setItem("businessNo", this.payInfo.businessNo)
      localStorage.setItem("payType", this.payInfo.payType)
      localStorage.setItem("payMoney", this.payInfo.payMoney)
    },
    // //支付完成
    // payOk(){
    //   // axios.get('https://www.agr580.com:9000/ICBalanceEx_2008_JN_EX/qrpay/queryPayFee.do',this.payInfo).then(res=>{
    //   //   console.log("支付完成提示",res);
    //   //   if(res.retCode == '0'){
    //     //信息存入缓存  
    //     localStorage.setItem("deveiceNo",this.payInfo.deveiceNo)
    //     localStorage.setItem("businessNo",this.payInfo.businessNo)
    //     localStorage.setItem("payType",this.payInfo.payType)
    //     localStorage.setItem("payMoney",this.payInfo.payMoney)
    //       this.$router.push({name: 'order'})
    //   //   }
    //   // }).catch(err=>{
    //   // })     
    // }


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.chameleon {
  background: #fff;
}

.corporate-name {
  width: 100%;
  padding-top: 10px;
  font-size: 30px;
  color: #155642;
  text-align: center;
}

.corporate-name img {
  width: 160px;
  height: 50px;
}

.product-name {
  width: 100%;
  text-align: center;
  padding: 10px 0px;
  color: #51A790;
  font-weight: 400;
  font-size: 23px;
}

.export {
  width: 100%;
  text-align: center;
  color: #ee0a24;
  font-size: 24px;
  /* margin-top: 10px; */
}

.export-info {
  width: 100%;
  margin-top: 20px;
  padding-top: 10px;
  padding-bottom: 20px;
  border-top: #F2F2F2 solid 1px;
  border-bottom: #F2F2F2 solid 1px;
}

.plate {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 15px 32px;
  background: #F9F9F9;
  margin-top: 3px;
}

.plate2 {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 15px 32px;
  background: #F9F9F9;
  margin-top: 3px;
}

.plate-left {
  display: flex;
  flex-direction: row;
  font-size: 17px;
  color: #1F1A17;
  font-weight: 500;
}

.plate-left span {
  font-size: 17px;
  color: #DA251D;
  margin-left: 10px;
}

.righ-class {
  color: #1F1A17;
  font-size: 17px;
  font-weight: 500;
}

.btn {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;

}

.el-button {
  border-radius: 8px;
  font-size: 18px;
}</style>
<style>@media (max-width:720px) {
  .msgbox {
    width: 320px !important;
  }
}</style>



// WEBPACK FOOTER //
// src/components/index.vue